import angular from 'angular';
import cannyEnhancementsNz from './cannyEnhancementsNz';

export default angular
  .module('components.cannyEnhancementsNz', [])
  .component('cannyEnhancementsNz', cannyEnhancementsNz).name;
